<script setup>
	import {
		computed,
	} from 'vue';
	import { DsText, DsGrid, DsTooltip, DsAlert } from "@coloplast/design-system";
	import { useStore } from 'vuex';
	import '@coloplast/design-system/dist/components/tooltip/ds-tooltip.css';

	const store = useStore();

	const props = defineProps({
		maxAllowedSamples: {
			type: String,
			default: null
		},
		maxSamplesWarningMessage : {
			type: String,
			default: null
		},
	});

	const
		selectedVariant = computed(() => store.getters.getSelectedVariant),
		numberOfBasketItems = computed(() => store.getters.getBasketItemCount),
		maximumNumberOfItemsReached = computed(() => numberOfBasketItems.value == props.maxAllowedSamples),
		datasheetItems = computed(() => {
			if (selectedVariant.value) {
				return selectedVariant.value.VariantDataSheetItems.filter((item) => !!item.Value)
			}
			return [];
		});
</script>

<template>
	<DsGrid
			v-if="datasheetItems.length > 0 && !maximumNumberOfItemsReached"
			v-bind="{columns:2, columnsSm:4, htmlElement:'div', type:'equal-columns'}"
			>
			<div
				 data-testid="datasheet-item"
				 class="c-datasheet-column"
				 v-for="item in datasheetItems"
				 >
				<DsText html-element="div"
						text-type="body-sm"
						text-style="medium"
						v-html="item.Key" />
				<DsTooltip :text="item.Value" placement="top">
					<DsText html-element="a"
							text-type="body-sm"
							text-style="regular"
							v-html="item.Value"
							class="c-datasheet-value" />
				</DsTooltip>
			</div>
	</DsGrid>
	<DsAlert v-if="maximumNumberOfItemsReached && maxSamplesWarningMessage" :text="maxSamplesWarningMessage" appearance="attention" />
</template>
